import InvitationCard from './InvitationCard';

export default InvitationCard;
